import { Select, MenuItem, Typography, Grid } from "@mui/material";
import { colors } from "common";
import { FilterData } from "modules/blogs/types";
import React, { FC } from "react";
import CheckIcon from "@mui/icons-material/Check";
import { SelectValue } from "./SelectValue";
import { fontSize } from "theme/typography";

interface Props {
  value?: string[];
  disabled?: boolean;
  onChange?: (val: string[], fieldName: string) => void;
  filter?: FilterData;
  title?: string;
  fieldName?: string;
}

export const TopbarFilter: FC<Props> = ({
  value,
  onChange,
  filter,
  title,
  disabled,
  fieldName,
}) => {
  return filter?.label ? (
    <Grid
      item
      lg={3.2}
      md={3.2}
      sx={{
        display: "flex",
        flexDirection: "column",
        textAlign: "left",
        width: "100%",
      }}
    >
      <Typography fontSize="12px">{title}</Typography>
      <Select
        disabled={disabled}
        multiple
        value={value}
        onChange={(e) => onChange(e.target.value as string[], fieldName)}
        renderValue={(selected) => <SelectValue selected={selected} />}
        inputProps={{
          sx: { py: ".5em" },
        }}
        sx={{
          background: "white",
        }}
      >
        <MenuItem
          // disable picking menu item when page is loading to avoid bugs
          disabled={disabled}
          value={"all"}
          sx={{
            display: "flex",
            justifyContent: "space-between",
            color: value.includes("all") ? colors.error : "initial",
          }}
        >
          All
          {value.includes("all") && <CheckIcon sx={{ color: colors.error }} />}
        </MenuItem>
        {filter?.options[0] &&
          filter.options.map((i, ind) => (
            <MenuItem
              disabled={disabled}
              key={ind}
              value={i}
              sx={{
                display: "flex",
                justifyContent: "space-between",
                color: value.includes(i) ? colors.error : "initial",
              }}
            >
              {i}
              {value.includes(i) && <CheckIcon sx={{ color: colors.error }} />}
            </MenuItem>
          ))}
      </Select>
    </Grid>
  ) : null;
};
